import { Component } from '@angular/core';
import { soundpostReportOutputAccountActivitySummaryEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Report Output Account Activity Summaries') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreportoutputaccountactivitysummary-form',
    templateUrl: './soundpostreportoutputaccountactivitysummary.form.component.html'
})
export class soundpostReportOutputAccountActivitySummaryFormComponent extends BaseFormComponent {
    public record!: soundpostReportOutputAccountActivitySummaryEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

